// assets/auto-open-cart.js
// Add to cart 후 cart drawer를 제대로 렌더링하고 열기
(function () {
  async function addToCartAndOpenDrawer(form) {
    const cartDrawer = document.querySelector('cart-drawer');
    const formData = new FormData(form);

    // cart-drawer가 렌더링할 섹션들을 sections 파라미터에 포함
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      const sections = cartDrawer.getSectionsToRender().map((s) => s.id);
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });

      if (!res.ok) {
        form.submit();
        return;
      }

      const response = await res.json();

      // cart-drawer에 새 내용 렌더링 + 자동 열기
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(response);
      }
    } catch (err) {
      console.error('auto-open-cart error:', err);
      form.submit();
    }
  }

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form) return;
    if (form.getAttribute('action') === '/cart/add') {
      e.preventDefault();
      addToCartAndOpenDrawer(form);
    }
  });
})();